import React, { useEffect, useRef, useState } from "react";
import { ColorType, createChart } from "lightweight-charts";
import "./BalanceChart.scss";
import arrowDown from "../../../Assets/Images/lossArrow.svg";
import arrowUp from "../../../Assets/Images/winArrow.svg";
import { SocketIo } from "App";
import { useSelector } from "react-redux";
import { isWithinOneMinute } from "utils";
import { useTheme } from "hooks/ThemeContext";
const BalanceChart = ({
  chartData,
  title,
  subTitle,
  status,
  info,
  price,
  currency,
  variant,
  symbol,
  entryTitle,
  entryPrice,
  change,
  onClick,
  login,
  height = 100,
}) => {
  const { theme } = useTheme();
  const backgroundColor = "transparent";
  const lineColor = theme === "dark" ? "white" : "black";
  const textColor = theme === "dark" ? "black" : "white";
  const areaTopColor = "transparent";
  const areaBottomColor = "transparent";
  const chartContainerRef = useRef(null);

  const [data, setData] = useState([]);

  useEffect(() => {
    setData(chartData);
  }, [chartData]);

  useEffect(() => {
    if (data?.length > 0) {
      const handleOrderProfit = (dataInner) => {
        if (dataInner?.login === login) {
          if (
            isWithinOneMinute(
              dataInner.createdAt,
              new Date(data[data?.length - 1]?.time * 1000).toISOString(
                "en-US" // Convert the time to ISO string
              )
            )
          ) {
            const d = [...data];
            d.push({
              time: new Date(dataInner.createdAt)?.getTime() / 1000,
              value: dataInner.equity,
            });
            setData(d);
          } else {
            const d = [...data];
            d[d?.length - 1] = {
              ...d[d?.length - 1],
              value: dataInner.equity,
            };
            setData(d);
          }
        }
      };
      SocketIo.on("onOrderProfit", handleOrderProfit);
    }

    return () => {
      SocketIo.off("onOrderProfit");
    };
  }, [login, data]);

  useEffect(() => {
    // Create the chart instances
    const chart = createChart(chartContainerRef.current, {
      height: height,

      layout: {
        background: { type: ColorType.Solid, color: backgroundColor },
        textColor: textColor,
      },

      handleScroll: {
        mouseWheel: false,
      },
      handleScale: {
        mouseWheel: false,
      },

      grid: {
        vertLines: { visible: false }, // Hide vertical grid lines
        horzLines: { visible: false }, // Hide horizontal grid lines
      },
      timeScale: {
        visible: false,
      }, // Remove time scale
      trackingMode: 0,

      rightPriceScale: {
        visible: false,
      }, // Remove price scale
      leftPriceScale: { visible: false, autoScale: false }, // Remove price scale
      crosshair: {
        mode: 2,
      },
    });

    // Add the area series
    const areaSeries = chart.addAreaSeries({
      lineColor,
      lineWidth: 2,

      topColor: areaTopColor,
      bottomColor: areaBottomColor,
      lastValueVisible: false,
      priceLineVisible: false,
    });
    areaSeries.setData(data);

    chart.applyOptions({
      watermark: {
        color: "rgba(0, 0, 0, 0)",
        visible: false,
        text: "",
        fontSize: 24,
        horzAlign: "left",
        vertAlign: "top",
      },
    });

    return () => {
      chart.remove();
    };
  }, [data]);

  return (
    <>
      {variant != "secondary" ? (
        <div
          className={`chart_cont rounded-xl  w-full h-full cursor-pointer`}
          onClick={() => onClick && onClick()}
        >
          <div ref={chartContainerRef}></div>

          <div className="left-0 pt-0 z-10">
            <div className="text-white-opacity text-xs ">{info}</div>
            <div className="text-baseColor text-2xl font-N_Bold flex gap-1 items-baseline ">
              {price?.toLocaleString("en-US", {
                style: "currency",
                currency: currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 3,
              })}

              <div className="text-xs text-white-opacity">{currency}</div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="chart_cont w-full h-full"
          onClick={() => onClick && onClick()}
        >
          <div ref={chartContainerRef}></div>
        </div>
      )}
    </>
  );
};

export default BalanceChart;
